/*
 * @Author: Teemo Ding
 * @Date: 2022-02-15 11:42:44
 * @LastEditTime: 2022-06-06 10:36:38
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Communication/Detail/CommunicationGateway/index.tsx
 */
import { Button, Input, Label, TextArea } from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { saveCommunicationGateway } from '@/src/request/settings/communication';
import {
  CommunicationGatewayProvider,
  SendFromType,
} from '@/src/types/common/communication';
import { useRequest } from 'ahooks';
import { Form, message } from 'antd';
import { cloneDeep } from 'lodash';
import React, { Fragment, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { NEW } from 'src/tools/constant';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { InputWithValue } from '../../Components/FormComponents';
import { calculateCommunication } from '../../tool';
import css from '../css.module.less';
import { IParams } from '../index';
import Cloopen from './Components/Cloopen';
import Sendgrid from './Components/Sendgrid';
import Twilio from './Components/Twilio';
import Zhima from './Components/Zhima';

export const sendFromOptions = [
  {
    value: SendFromType.Mobile,
    label: 'Phone Number',
    span: 'send SMS from a specific phone number',
  },
  {
    value: SendFromType.SenderId,
    label: 'Alphanumeric Sender ID',
    span: 'Personalize Your SMS Messages with an Alphanumeric Sender ID',
  },
];
const CommunicationGateway = ({
  form,
  communicationInitial,
  disableEdit,
  onSaveSuccess,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const history = useHistory();
  const [unlockEditable, setUnlockEditable] = useState([]);
  const { gateway, channelType, communicationUuid } = useParams() as IParams;
  //const isPhoneValidation =
  //  channelType === CommunicationChannelType.PhoneNumberValidation;
  const [edit, setEdit] = useState(false);
  const editable = edit || communicationUuid === NEW;

  const handleResetInput = (key) => {
    form.setFieldsValue({ [key]: '' });
    const unlockEditableCopy = cloneDeep(unlockEditable);
    unlockEditableCopy.push(key);
    setUnlockEditable(unlockEditableCopy);
  };

  const { run: _saveCommunicationGateway } = useRequest(
    (data) => saveCommunicationGateway(data),
    {
      manual: true,
      onSuccess: (res) => {
        message.success('saved successfully!');
        setEdit(false);
        if (communicationUuid === NEW && res.uuid) {
          history.replace(
            `/settings/communicationDetail/${gateway}/${channelType}/${res.uuid}`,
          );
        }
        onSaveSuccess?.();
      },
    },
  );

  const onFinish = (values) => {
    const {
      name,
      remarks,
      accountSid,
      authToken,
      sendFrom,
      serviceSid,
      phoneNumber,
      appId,
      host,
      port,
      destination,
      apiKeys,
      url,
      unsubscribeGroupId,
    } = values;
    const { areaCode, mobileNumber, areaCodeInfo } = phoneNumber || {};
    const data = {
      uuid: communicationUuid === NEW ? '' : communicationUuid,
      name,
      gatewayProvider: gateway,
      channelType,
      remarks,

      settings: {
        gatewayProvider: gateway,
        appId,
        host,
        port,
        destination,
        apiKeys,
        url,
        accountSid,
        authToken,
        sendFrom,
        serviceSid,
        areaCode,
        areaCodeInfo,
        mobile: mobileNumber,
        unsubscribeGroupId:
          unsubscribeGroupId != null ? Number(unsubscribeGroupId) : undefined,
      },
    };
    _saveCommunicationGateway(data);
  };

  const handleDiscard = () => {
    const { gateway } = communicationInitial || {};
    const { name = '', remarks = '', settings } = gateway || {};
    const {
      accountSid = '',
      authToken = '',
      appId = '',
      host = '',
      port = '',
      destination = '',
      apiKeys = '',
      url = '',
      sendFrom = SendFromType.Mobile,
      serviceSid = '',
      areaCode = '',
      areaCodeInfo,
      mobile: mobileNumber = '',
      unsubscribeGroupId,
    } = settings || {};
    form.setFieldsValue({
      name,
      remarks,
      accountSid,
      authToken,
      sendFrom,
      serviceSid,
      appId,
      host,
      port,
      destination,
      apiKeys,
      url,
      unsubscribeGroupId,
      phoneNumber: { areaCodeInfo, areaCode, mobileNumber },
    });
    setEdit(false);
  };

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={`${getI18n(
        'storeCommunicationSetting.list.communicationGateway',
      )} - ${
        calculateCommunication(gateway, channelType, { getI18n }).gateway
      }`}>
      <Form name='communicationDetail' form={form} onFinish={onFinish}>
        <Row
          elements={[
            {
              child: (
                <Form.Item
                  name='name'
                  rules={[
                    {
                      required: true,
                      message: replaceI18nVariables(
                        getI18n('general.fieldisrequired'),
                        getI18n(
                          'storeCommunicationSetting.list.communicationGatewayName',
                        ),
                      ),
                    },
                  ]}
                  label={
                    !editable ? (
                      getI18n(
                        'storeCommunicationSetting.list.communicationGatewayName',
                      )
                    ) : (
                      <Label
                        title={`${getI18n(
                          'storeCommunicationSetting.list.communicationGatewayName',
                        )}*`}
                        rightSubTitle={getI18n(
                          'storeCommunicationSetting.common.thisisforinternaluse',
                        )}
                        textLength={100}
                        nameKey='name'
                      />
                    )
                  }
                  labelCol={{ span: 24 }}>
                  {
                    <InputWithValue edit={editable}>
                      <Input
                        maxLength={100}
                        size='large'
                        disabled={disableEdit}
                      />
                    </InputWithValue>
                  }
                </Form.Item>
              ),
            },
            {
              child: (
                <Form.Item
                  name='remarks'
                  label={
                    !editable ? (
                      `${getI18n(
                        'storeCommunicationSetting.list.communicationGateway',
                      )}${getI18n('general.remarks')}`
                    ) : (
                      <Label
                        title={`${getI18n(
                          'storeCommunicationSetting.list.communicationGateway',
                        )} ${getI18n('general.remarks')} (${getI18n(
                          'general.optional',
                        )})`}
                        rightSubTitle={getI18n(
                          'storeCommunicationSetting.common.thisisforinternaluse',
                        )}
                        textLength={500}
                        nameKey='remarks'
                      />
                    )
                  }
                  labelCol={{ span: 24 }}>
                  <InputWithValue edit={editable}>
                    <TextArea
                      maxLength={500}
                      autoSize={{ maxRows: 1 }}
                      size='large'
                      disabled={disableEdit}
                    />
                  </InputWithValue>
                </Form.Item>
              ),
            },
          ]}
        />
        {gateway === CommunicationGatewayProvider.Twilio && (
          <Twilio
            editable={editable}
            communicationUuid={communicationUuid}
            handleResetInput={handleResetInput}
            unlockEditable={unlockEditable}
            disabled={disableEdit}
            //isPhoneValidation={isPhoneValidation}
          />
        )}
        {gateway === CommunicationGatewayProvider.Cloopen && (
          <Cloopen
            editable={editable}
            communicationUuid={communicationUuid}
            handleResetInput={handleResetInput}
            unlockEditable={unlockEditable}
            disabled={disableEdit}
          />
        )}
        {gateway === CommunicationGatewayProvider.Sendgrid && (
          <Sendgrid
            editable={editable}
            communicationUuid={communicationUuid}
            unlockEditable={unlockEditable}
            handleResetInput={handleResetInput}
            disabled={disableEdit}
          />
        )}
        {gateway === CommunicationGatewayProvider.Zhima && (
          <Zhima editable={editable} disabled={disableEdit} />
        )}
      </Form>

      <div className={css.createButton}>
        {communicationUuid === NEW && (
          <Button type='primary' onClick={form.submit} disabled={disableEdit}>
            {getI18n('general.create')}
          </Button>
        )}
        {communicationUuid !== NEW && !edit && (
          <Button
            type='primary'
            onClick={() => setEdit(true)}
            disabled={disableEdit}>
            {getI18n('general.edit')}
          </Button>
        )}
        {edit && (
          <Fragment>
            <Button type='primary' onClick={form.submit} disabled={disableEdit}>
              {getI18n('general.save')}
            </Button>
            <Button onClick={handleDiscard} className={css.discard}>
              {getI18n('general.discard')}
            </Button>
          </Fragment>
        )}
      </div>
    </SectionWrapper>
  );
};

export default CommunicationGateway;
